import type { FC } from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'

import './index.styles.css'

export type SearchItem = {
  id: string
  name: string
  description?: string
  avatar?: string
  type: string
}

type Props = {
  item: SearchItem
  onClick: (item: SearchItem) => void
}

const SearchBarItem: FC<Props> = ({ item, onClick }) => {
  return (
    <Box
      className={'SearchBarItem_hover'}
      flexDirection="row"
      paddingX="s32"
      paddingY="s16"
      alignItems="center"
      onClick={() => onClick(item)}
    >
      <Avatar size="s32" label={item.name} url={buildUrl(item?.avatar)} />
      <Box paddingX="s12">
        <Text.Normal color="grey800" weight="semibold">
          {item.name}
        </Text.Normal>
        <Text.Normal color="grey800" weight="medium">
          {item.description || ''}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default SearchBarItem
